export default __webpack_public_path__ + "static/media/17.8cbc9212.png";